import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    NgZone,
    OnDestroy,
} from '@angular/core';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { AuthService } from './guard.service';
import * as firebase from 'firebase/app';

@Component({
    selector: 'user-bar',
    templateUrl: './userbar.component.html',
    styleUrls: ['./userbar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserbarComponent implements OnDestroy {

    private sub : Subscription
    currentUser : firebase.User

    constructor(public auth : AuthService, private ref: ChangeDetectorRef) {
        this.sub = this.auth.user.subscribe(user => {
            this.currentUser = user;
            this.ref.markForCheck();
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    login() {
        this.auth.loginGoogle();
    }

    logout() {
        this.auth.logout();
    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/auth/userbar.component.ts